import api from "./api";
export const getLinkReport = async (data) => {
    return await api.post(`https://api.cmsdeployer.com/api/domain-prime-time/domain_list_with_population`,data);
  };
  export const insertInRobo = async (data) => {
    return await api.post(`https://api.roboanywhere.com/api/common/save_domain_list_with_population`,data);
  };